import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import client from '../../lib/feathers';

export default function NewWineTypeForm(props) {
  const { onCancelClick, onNewWineType, onUpdateWineType, wineType } = props;
  const [name, setName] = useState('');

  const isEditing = !!wineType;

  useEffect(() => {
    if (wineType) {
      setName(wineType.name || '');
    }
  }, [wineType]);

  const onFormSubmit = async (event) => {
    event.preventDefault();
    const service = client.service('admin/libation-type');

    if (!name.trim()) {
      toast.error('Please enter a name');
      return;
    }

    const data = { name: name.trim() };

    try {
      if (isEditing) {
        const result = await service.patch(wineType.id, data);
        onUpdateWineType(result);
        toast.success(`Updated ${name}`);
      } else {
        const result = await service.create(data);
        onNewWineType(result);
        toast.success(`Added ${name}`);
      }
    } catch (e) {
      console.error('Error saving wine type:', e);
      toast.error(isEditing ? 'Failed to update wine type' : 'Failed to create wine type');
    }
  };

  return (
    <>
      <div className="mt-3 text-center sm:mt-5">
        <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
          {isEditing ? 'Edit Wine Type' : 'Create New Wine Type'}
        </h3>
        <div className="mt-2">
          <p className="text-sm text-gray-500">
            {isEditing ? 'Update the wine type name.' : 'Enter the name for this wine type.'}
          </p>
          <form onSubmit={onFormSubmit} className="mt-4">
            <div className="mb-4">
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 text-left">
                Name
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                name="name"
                id="name"
                autoComplete="off"
                placeholder="e.g., Still, Sparkling, Fortified"
                className="mt-1 focus:ring-gray-500 focus:border-gray-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
              <button
                type="submit"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-red-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:col-start-2 sm:text-sm"
              >
                {isEditing ? 'Save' : 'Create'}
              </button>
              <button
                type="button"
                onClick={onCancelClick}
                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:col-start-1 sm:text-sm"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
